export const SetupSteps = {
  OtherMethodIsAlreadySetup: 0,
  Initial: 1,
  Confirmation: 2,
  Completed: 3
}
